import { doc, getDoc, collection, getDocs, query, where } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { db } from '../firebase/config';

const auth = getAuth();

export const fetchQuestions = async (categories: string[]) => {
    const user = auth.currentUser;
    if (!user) throw new Error("User not authenticated");

    try {
        // Get user's custom physical question
        const userDocRef = doc(db, `users/${user.uid}`);
        const userDoc = await getDoc(userDocRef);
        let customPhysicalQuestion: any = null;

        if (userDoc.exists() && userDoc.data().customPhysical?.active) {
            const customPhysical = userDoc.data().customPhysical;
            customPhysicalQuestion = {
                question: customPhysical.question,
                answers: [
                    customPhysical.a1,
                    customPhysical.a2,
                    customPhysical.a3,
                    customPhysical.a4,
                    customPhysical.a5,
                    customPhysical.a6,
                    customPhysical.a7,
                ],
                title: customPhysical.title || null,
                video: customPhysical.video || null,
            };
        }

        // Fetch questions from Firestore version2 database
        const questionsRef = collection(db, "wellnessQuestions");
        const questionsQuery = query(questionsRef, where("active", "==", true));
        const snapshot = await getDocs(questionsQuery);

        if (snapshot.empty) {
            throw new Error("No questions found in database");
        }

        const questions: Record<string, any> = {};

        // Process questions by category
        categories.forEach(category => {
            const categoryQuestions = snapshot.docs
                .map(doc => doc.data())
                .filter((q: any) => q.category === category)
                .map((q: any) => ({
                    question: q.question,
                    answers: q.answers || [],
                    title: q.title || null,
                    video: q.video || null,
                }));

            if (category === "physical" && customPhysicalQuestion) {
                questions[category] = customPhysicalQuestion;
            } else if (categoryQuestions.length > 0) {
                questions[category] = categoryQuestions[Math.floor(Math.random() * categoryQuestions.length)];
            }
        });

        return questions;
    } catch (error) {
        console.error("Error fetching questions:", error);
        throw error;
    }
}; 